import {
  addressProperties,
  addressRequired,
  customValidate
} from 'common/components/address/validators';
import { validateForUI } from 'common/helpers/jsonValidator';

const loggedInCustomer = () => {
  const schema = {
    type: 'object',
    properties: addressProperties,
    required: addressRequired,
    additionalProperties: false
  };
  schema.properties.customerAddressId = { type: 'string' };
  return schema;
};

const notLoggedInCustomer = () => {
  const schema = {
    type: 'object',
    properties: addressProperties,
    required: addressRequired,
    additionalProperties: false
  };
  return schema;
};

export const validateAddressForLoggedInCustomer = (address, settings) => {
  const errors = validateForUI(
    loggedInCustomer(),
    address,
    customValidate(address, 'billing', settings)
  );
  return errors;
};

export const validateAddressForNotLoggedInCustomer = (address, settings) => {
  const errors = validateForUI(
    notLoggedInCustomer(),
    address,
    customValidate(address, 'billing', settings)
  );
  return errors;
};
